import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.experience__img')) {
        const imageSlider = document.querySelector('.experience__img');

        const experienceSwiper = new Swiper('.experience__slider', {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            speed: 3000,
            allowTouchMove: false,
            autoplay: {
                delay: 3000,
                disableOnInteraction: true,
            },
            on: {
                slideChangeTransitionStart: function () {
                    imageSlider.classList.add('animate');
                },
                slideChangeTransitionEnd: function () {
                    imageSlider.classList.remove('animate');
                }
            }
        });

        window.addEventListener('resize', function () {
            imageSlider.classList.remove('animate');
        });
    }
});
